import { GenderFemale } from "./GenderFemale";
import { GenderMale } from "./GenderMale";
import { GenderOther } from "./GenderOther";

export { GenderFemale, GenderMale, GenderOther };
